import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";

const useLoadUSpositions = (url, reloadPoslistdata) => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  // States
  const [listdata, setListdata] = useState([]);
  useEffect(() => {
    const controller = new AbortController();
    const getUSPositionsList = async () => {
      try {
        const response = await axiosPrivate.get(`/api/qs/${url}`);
        if (response.data.message !== "No positions exist.") {
          setListdata(response.data);
        }
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getUSPositionsList();
    return () => controller.abort();
  }, [reloadPoslistdata]);

  return listdata;
};

export default useLoadUSpositions;
